module.exports = __webpack_public_path__ + "static/media/Lens_Card_JP_new.6708a8db.png";